export enum Pipes {
  TITLE_CASE = 'titlecase',
}
